import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmComponent } from '../../../../../components/ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../../../models/action-confirm.model';
import { OpeningClosingHoursRequest, OpeningClosingHoursRequestSearch, OpeningClosingHoursType } from '../../../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { SpecialOpeningClosingHoursRequest, SpecialOpeningClosingHoursRequestSearch, SpecialOpeningClosingHoursType } from '../../../../../models/api-store/special-opening-closing-hours/special-opening-closing-hours.request.model';
import { OpeningClosingHoursService } from '../../../../../services/api-store/opening-closing-hours/opening-closing-hours.service';
import { SpecialOpeningClosingHoursService } from '../../../../../services/api-store/special-opening-closing-hours/special-opening-closing-hours.service';
import { StoreService } from '../../../../../services/api-store/store/store.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { DIALOG_MEDIUM_CONFIG } from '../../../../../utils/config/modal-settings';
import { FALSE, TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-gestioneorari-edit',
  templateUrl: './gestioneorari-edit.component.html',
  styleUrls: ['./gestioneorari-edit.component.css']
})
export class GestioneorariEditComponent implements OnInit {

  @Input() storeId: number;
  @Input() type: string;

  infoStoreTitle: string = "";

  //Tabella orari
  idOpeningclosinghours: number;
  isValidOpeningclosinghours: boolean = false;
  hasOriginalOpeningclosinghours: boolean = false;
  outputOpeningclosinghoursTable: any = {};
  inputOpeningclosinghoursTable: OpeningClosingHoursRequest;

  //Aperture Straordinarie
  inputSpecialOpeningHours: SpecialOpeningClosingHoursRequest;
  outputSpecialOpeningHours: any = {}
  isValidSpecialOpeninghours: boolean = false;
  archiveSpecialOpeningHours: any = []
  futureSpecialOpenighours: any = [];
  pastSpecialOpenighours: any = [];


  //Chiusure straordinarie
  inputSpecialClosingHours: SpecialOpeningClosingHoursRequest;
  outputSpecialClosingHours: any = {}
  isValidSpecialClosinghours: boolean = false;
  archiveSpecialClosingHours: any = []
  futureSpecialClosinghours: any = [];
  pastSpecialClosinghours: any = [];



  constructor(
    private storeService: StoreService,
    private openingClosingHoursService: OpeningClosingHoursService,
    private specialOpeningClosingHoursService: SpecialOpeningClosingHoursService,
    private spinner: SpinnerService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initInfoStore();
    this.initOpeningClosingHours();
    this.initSpecialOpeningHours();
    this.initSpecialClosingHours();
    this.getListSpecialOpenighours();
    this.getListSpecialClosinghours();
  }

  initInfoStore() {
    if (typeof this.storeId != typeof undefined) {
      this.storeService.getEntity(this.storeId).subscribe(
        (response) => {
          if (response) {
            console.log(response);
            this.infoStoreTitle = response.title + " - " + response.titleSeo + " - " + response.dealerCategory;
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni', 'Informazioni store', {
            timeOut: 5000
          });
          this.spinner.hide();
        }
      );
    }
  }

  /**
   * Inizializza i dati della tabella orari
   */
  initOpeningClosingHours() {
    if (typeof this.storeId === typeof undefined) {
      this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
      return;
    }
  
    const handleResponse = (response, originalType) => {
      console.log(response);
      if (!response || response.total === 0) {
        if (this.type !== 'CUSTOM') {
          // Nothing else to try, so initialize an empty table
          this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
        } else {
          // Check if hours are available on the "Standard" store with same storeId
          searchOpeningHours(OpeningClosingHoursType.STANDARD, OpeningClosingHoursType[this.type]);
        }
        this.spinner.hide();
        return;
      }

      if (originalType) {
        // Reset type and idOpeningclosinghours, otherwise the "Standard" store will be updated
        response.data[0].type = OpeningClosingHoursType[originalType];
        this.idOpeningclosinghours = undefined;
        this.hasOriginalOpeningclosinghours = true;
      } else {
        this.idOpeningclosinghours = response.data[0].id;
      }

      this.inputOpeningclosinghoursTable = response.data[0];

      this.spinner.hide();
    }
  
    const handleErrorResponse = (error: HttpErrorResponse) => {
      console.error(error);
      this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni', 'Modifica orari custom', {
        timeOut: 5000
      });
      this.spinner.hide();
    }

    const searchOpeningHours = (type: OpeningClosingHoursType, originalType: OpeningClosingHoursType = null) => {
      const openingClosingHoursRequestSearch = new OpeningClosingHoursRequestSearch();
      openingClosingHoursRequestSearch.storeId = this.storeId;
      openingClosingHoursRequestSearch.type = type;
  
      this.openingClosingHoursService.search(openingClosingHoursRequestSearch).subscribe(
        (response) => {
          handleResponse(response, originalType)
        },
        handleErrorResponse,
      );
    }
  
    searchOpeningHours(OpeningClosingHoursType[this.type]);
  }  


  /**
   * Inizializza la maschera di inserimento apertura straordinaria 
   */
  initSpecialOpeningHours() {
    this.inputSpecialOpeningHours = new SpecialOpeningClosingHoursRequest();
  }

  /**
   * Inizializza la maschera di inserimento chiusura straordinaria 
   */
  initSpecialClosingHours() {
    this.inputSpecialClosingHours = new SpecialOpeningClosingHoursRequest();
  }


  /*  AZIONI */

  /**
   * Salva modifiche
   */
  saveOpeningclosinghours() {
    let request = this.outputOpeningclosinghoursTable;
    request.storeId = this.storeId;
    request.type = OpeningClosingHoursType[this.type];
    if (this.isValidOpeningclosinghours == TRUE) {
      if (typeof this.idOpeningclosinghours != typeof undefined) {
        //Update
        this.openingClosingHoursService.update(this.idOpeningclosinghours, request).subscribe(
          (response) => {
            if (response) {
              this.hasOriginalOpeningclosinghours = false;
              this.toastr.success('Orari custom modificati con successo', 'Modifica orari custom');
              this.cancel();
            }
            this.spinner.hide();
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error('Si è verificato un errore durante la modifica degli orari custom', 'Creazione orari custom fallita', {
              timeOut: 5000
            });
            this.spinner.hide();
            this.cancel();
          }
        );
      } else {
        //Create
        this.openingClosingHoursService.create(request).subscribe(
          (response) => {
            if (response) {
              this.idOpeningclosinghours = response.id;
              this.hasOriginalOpeningclosinghours = false;
              this.toastr.success('Orari custom creati con successo', 'Modifica orari custom');
            }
            this.spinner.hide();
            this.cancel();
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error('Si è verificato un errore durante la creazione degli orari custom', 'Creazione orari custom fallita', {
              timeOut: 5000
            });
            this.spinner.hide();
            this.cancel();
          }
        );
      }
    }
  }

  /**
   * Annulla
   */
  cancel() {
    this.activeModal.close('Close click');
  }

  /**
   * Aggiungi nuova - apertura straordinaria
   */
  saveSpecialOpeninghours() {
    if (this.isValidSpecialOpeninghours) {
      let request = this.outputSpecialOpeningHours;
      request.type = SpecialOpeningClosingHoursType.OPENING;
      request.storeId = this.storeId;
      this.specialOpeningClosingHoursService.create(request).subscribe(
        (response) => {
          if (response) {
            this.initSpecialOpeningHours();
            this.getListSpecialOpenighours();
            this.toastr.success('Apertura straordinaria salvata con successo', 'Crea apertura straordinaria');
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error('Si è verificato un errore durante la creazione del apertura straordinaria', 'Crea apertura straordinaria fallita', {
            timeOut: 5000
          });
          this.spinner.hide();
        }
      );
    }
  }

  /**
   * Aggiungi nuova - chiusura straordinaria
   */
  saveSpecialClosinghours() {
    if (this.isValidSpecialClosinghours) {
      let request = this.outputSpecialClosingHours;
      request.type = SpecialOpeningClosingHoursType.CLOSING;
      request.storeId = this.storeId;
      this.specialOpeningClosingHoursService.create(request).subscribe(
        (response) => {
          if (response) {
            this.initSpecialClosingHours();
            this.getListSpecialClosinghours();
            this.toastr.success('Chiusura straordinaria salvata con successo', 'Crea chiusura straordinaria');
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error('Si è verificato un errore durante la creazione del chiusura straordinaria', 'Crea chiusura straordinaria fallita', {
            timeOut: 5000
          });
          this.spinner.hide();
        }
      );
    }
  }




  /* AGGIORNA VALORI  */

  /**
   * Aggiorna valori della tabella orari
   * @param $event 
   */
  changeTableHours($event) {
    if ($event.status === "VALID") {
      this.isValidOpeningclosinghours = (TRUE && $event.touched);
    } else {
      this.isValidOpeningclosinghours = (FALSE && $event.touched);
    }
    this.outputOpeningclosinghoursTable = $event.output;
  }

  /**
   * Aggiorna dati nuova apertura straordinaria
   * @param $event 
   */
  changeSpecialOpeningHours($event) {
    if ($event.status === "VALID") {
      this.isValidSpecialOpeninghours = (TRUE && $event.touched);
    } else {
      this.isValidSpecialOpeninghours = (FALSE && $event.touched);
    }
    this.outputSpecialOpeningHours = $event.output;
  }

  /**
   * Aggiorna dati nuova chiusura straordinaria
   * @param $event 
   */
  changeSpecialClosingHours($event) {
    if ($event.status === "VALID") {
      this.isValidSpecialClosinghours = (TRUE && $event.touched);
    } else {
      this.isValidSpecialClosinghours = (FALSE && $event.touched);
    }
    this.outputSpecialClosingHours = $event.output;
  }


  /*  LISTA VALORI ARCHIVE */

  /**
   * Archivio aperture straordinarie
   */
  getListSpecialOpenighours() {
    let request = new SpecialOpeningClosingHoursRequestSearch();
    request.pageSize = 50;
    request.pageNumber = 0;
    request.storeId = this.storeId;
    request.type = SpecialOpeningClosingHoursType.OPENING;
    request.sortBy = "date:desc";

    this.specialOpeningClosingHoursService.search(request).subscribe(
      (response) => {
        this.futureSpecialOpenighours = []
        this.pastSpecialOpenighours = [];
        this.archiveSpecialOpeningHours = response.data;
        this.archiveSpecialOpeningHours.forEach((item, i,) => {
          if (item.mFrom == "" || item.mFrom == null) { item.mFrom = "--:--"; }
          if (item.mTo == "" || item.mTo == null) { item.mTo = "--:--"; }
          if (item.eFrom == "" || item.eFrom == null) { item.eFrom = "--:--"; }
          if (item.eTo == "" || item.eTo == null) { item.eTo = "--:--"; }
          item.isVisibleDelete = true;
          let now = new Date();
          let objDate = new Date(item.date);
          objDate.setHours(23, 59, 59);
          if (objDate >= now) {
            //item.isVisibleDelete = true;
            this.futureSpecialOpenighours.push(item);
          } else {
            this.pastSpecialOpenighours.push(item);
          }
        });
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  /**
   * Archivio chiusure straordinarie
   */
  getListSpecialClosinghours() {
    let request = new SpecialOpeningClosingHoursRequestSearch();
    request.pageSize = 50;
    request.pageNumber = 0;
    request.storeId = this.storeId;
    request.type = SpecialOpeningClosingHoursType.CLOSING;
    request.sortBy = "date:desc";

    this.specialOpeningClosingHoursService.search(request).subscribe(
      (response) => {
        this.futureSpecialClosinghours = []
        this.pastSpecialClosinghours = [];
        this.archiveSpecialClosingHours = response.data;
        this.archiveSpecialClosingHours.forEach((item, i,) => {
          if (item.mFrom == "" || item.mFrom == null) { item.mFrom = "--:--"; }
          if (item.mTo == "" || item.mTo == null) { item.mTo = "--:--"; }
          if (item.eFrom == "" || item.eFrom == null) { item.eFrom = "--:--"; }
          if (item.eTo == "" || item.eTo == null) { item.eTo = "--:--"; }
          item.isVisibleDelete = true;
          let now = new Date();
          let objDate = new Date(item.date);
          objDate.setHours(23, 59, 59);
          if (objDate >= now) {
            //item.isVisibleDelete = true;
            this.futureSpecialClosinghours.push(item);
          } else {
            this.pastSpecialClosinghours.push(item);
          }
        });
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }


  /**
   * Azione click sul button delete aperture straordinarie
   * @param id 
   */
  clickButtonDeleteSpecialOpeninghours(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare l'apertura straordinaria?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.deleteSpecialOpeningHours(id);
        }
      }
    });
  }

  /**
   * Azione click sul button delete chiusure straordinarie
   * @param id 
   */
  clickButtonDeleteSpecialClosinghours(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare la chiusura straordinaria?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.deleteSpecialClosingHours(id);
        }
      }
    });
  }




  /**
   * Delete aperture straordinarie
   * @param id
   */
  deleteSpecialOpeningHours(id) {
    this.specialOpeningClosingHoursService.delete(id).subscribe(
      (response) => {
        this.toastr.success('Apertura straordinaria cancellata con successo', 'Cancella apertura straordinaria');
        for (let i = 0; i < this.futureSpecialOpenighours.length; i++) {
          if (this.futureSpecialOpenighours[i].id == id) {
            this.futureSpecialOpenighours.splice(i, 1);
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la cancellazione del apertura straordinaria', 'Cancella apertura straordinaria fallita', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  /**
   * Delete chiusure straordinarie
   * @param id 
   */
  deleteSpecialClosingHours(id) {
    this.specialOpeningClosingHoursService.delete(id).subscribe(
      (response) => {
        this.toastr.success('Chiusura straordinaria cancellata con successo', 'Cancella chiusura straordinaria');
        for (let i = 0; i < this.futureSpecialClosinghours.length; i++) {
          if (this.futureSpecialClosinghours[i].id == id) {
            this.futureSpecialClosinghours.splice(i, 1);
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la cancellazione della chiusura straordinaria', 'Cancella chiusura straordinaria fallita', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

}
